import { render, staticRenderFns } from "./PaymentTermForm.vue?vue&type=template&id=9b9d3aaa&"
import script from "./PaymentTermForm.vue?vue&type=script&lang=js&"
export * from "./PaymentTermForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports